import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { GameIntroScene } from "./GameIntro";
import { PickAFace } from "./PickAHead";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.FacePainting;
        this.mainScene = PickAFace;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "FacePainting.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "FacePainting.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "";
    }
}



// WEBPACK FOOTER //
// ./src/games/FacePainting/scenes/IntroductionScene.ts